import { SxProps, Theme } from '@mui/material';

export const styles: SxProps<Theme> = {
  borderRadius: '50%',
  display: 'inline-block',
};
